export default __webpack_public_path__ + "static/media/bell-regular.e81c07f7.svg";